import Vue from 'vue'
import App from './App.vue'
import store from './store'
// 引入Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@/assets/css/style.css'
// 或者如果你使用的是Bootstrap的SCSS版本
// import 'bootstrap/scss/bootstrap.scss';
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
// import '@/assets/css/theme.less'
import { message } from 'ant-design-vue'

// 页面加载时检查本地存储的token
const token = localStorage.getItem('token')
if (token) {
  // 如果存在token，将其存入store
  store.commit('SET_TOKEN', token)

  // 获取用户信息
  store
    .dispatch('GetInfo')
    .then(() => {
      // console.log('获取用户信息成功')
    })
    .catch(() => {
      // console.error('获取用户信息失败')
      // 如果获取失败，可能token已过期，清除token
      store.dispatch('Logout').then(() => {
        // console.log('获取用户信息失败')
      })
    })
}

Vue.config.productionTip = false

Vue.use(Antd)

Vue.prototype.$message = message
Vue.prototype.$store = store

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
